import React, { Component } from 'react'

import './SidePanel.scss'

export default class SidePanel extends Component {
  constructor() {
    super()
  }

  formatHeading = (heading) => {
    let out = heading
      .split('#').join('')
      .split('##').join('')
      .split('###').join('')
      return out;
  }


  getAllHeadings = (content) => {
    let headings = [];
    // if no content provided
    if(content.length === 0) return headings;
    // loop and find all headings
    content[0].children.map(child => {
      // consider only text elements
      if(child.type === 'text'){
        // consider only headings
        if(child.content.indexOf('##') > -1){
          headings.push(this.formatHeading(child.content));
        }
      }
    });
    return headings;
  }

  renderTitles = (titles) => {
    return titles.map((title,k) => {
      return (
      <div className='side__panel__option' key={k}>
        <a href={`#${title.split(' ').join('')}`}>{title}</a>
      </div>
      );
    });
  }

  render(){

    const { content } = this.props;
    const titles = this.getAllHeadings(content)

    return (
      <div className = 'side__panel' >
        <div className='side__panel__options'>
        { this.renderTitles(titles) }
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./component/ui/SidePanel/SidePanel.js